(function () {
  const ROOT_SELECTOR = 'variant-selects[data-dm-dependent-color-options="true"]';
  const COLOR_SELECTOR = '.product-form__input--color[data-option-position]';
  const HIDDEN_CLASS = 'dm-variant-option-hidden';

  function getVariantMatrix(root) {
    if (root.dmVariantMatrix) return root.dmVariantMatrix;

    const source = root.querySelector('[data-dm-variant-matrix]');
    if (!source) return [];

    try {
      const matrix = JSON.parse(source.textContent);
      root.dmVariantMatrix = Array.isArray(matrix) ? matrix : [];
    } catch (error) {
      root.dmVariantMatrix = [];
      console.error('Unable to read the product variant matrix.', error);
    }

    return root.dmVariantMatrix;
  }

  function getSelectedValue(fieldset) {
    const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
    if (checkedInput) return checkedInput.value;

    const select = fieldset.querySelector('select');
    return select ? select.value : '';
  }

  function getSelectedOptions(root) {
    const selected = new Map();

    root.querySelectorAll('[data-option-position]').forEach((fieldset) => {
      const position = Number(fieldset.dataset.optionPosition);
      const value = getSelectedValue(fieldset);
      if (position > 0 && value) selected.set(position, value);
    });

    return selected;
  }

  function variantMatchesSelections(variant, selections, ignoredPosition) {
    return Array.from(selections.entries()).every(([position, value]) => {
      if (position === ignoredPosition) return true;
      return variant.options?.[position - 1] === value;
    });
  }

  function setRelatedState(input, related) {
    const nextElement = input.nextElementSibling;
    const label =
      nextElement instanceof HTMLLabelElement && nextElement.htmlFor === input.id ? nextElement : null;

    if (!Object.prototype.hasOwnProperty.call(input.dataset, 'dmOriginallyDisabled')) {
      input.dataset.dmOriginallyDisabled = input.disabled ? 'true' : 'false';
    }

    input.disabled = !related || input.dataset.dmOriginallyDisabled === 'true';
    input.hidden = !related;
    input.classList.toggle(HIDDEN_CLASS, !related);

    if (label) {
      label.hidden = !related;
      label.classList.toggle(HIDDEN_CLASS, !related);
      label.setAttribute('aria-hidden', related ? 'false' : 'true');
    }
  }

  function chooseReplacementColor(colorInputs, validColors, matrix, selectedOptions, colorPosition) {
    const relatedInputs = colorInputs.filter((input) => validColors.has(input.value));
    if (!relatedInputs.length) return null;

    const replacementWithCurrentOptions = relatedInputs.find((input) =>
      matrix.some(
        (variant) =>
          variant.options?.[colorPosition - 1] === input.value &&
          variantMatchesSelections(variant, selectedOptions, colorPosition)
      )
    );

    return replacementWithCurrentOptions || relatedInputs[0];
  }

  function filterColorOptions(root) {
    const matrix = getVariantMatrix(root);
    const colorFieldset = root.querySelector(COLOR_SELECTOR);
    if (!matrix.length || !colorFieldset) return;

    const colorPosition = Number(colorFieldset.dataset.optionPosition);
    if (!colorPosition || colorPosition === 1) return;

    const selectedOptions = getSelectedOptions(root);
    const priorSelections = new Map(
      Array.from(selectedOptions.entries()).filter(([position]) => position < colorPosition)
    );

    const relatedVariants = matrix.filter((variant) =>
      variantMatchesSelections(variant, priorSelections, colorPosition)
    );
    const validColors = new Set(
      relatedVariants.map((variant) => variant.options?.[colorPosition - 1]).filter(Boolean)
    );

    if (!validColors.size) return;

    const colorInputs = Array.from(colorFieldset.querySelectorAll('input[type="radio"]'));
    const currentColor = colorInputs.find((input) => input.checked);

    colorInputs.forEach((input) => setRelatedState(input, validColors.has(input.value)));

    if (currentColor && validColors.has(currentColor.value)) return;

    const replacement = chooseReplacementColor(
      colorInputs,
      validColors,
      matrix,
      selectedOptions,
      colorPosition
    );

    if (replacement) replacement.checked = true;
  }

  function initialize(scope) {
    const roots = [];

    if (scope?.matches?.(ROOT_SELECTOR)) roots.push(scope);
    scope?.querySelectorAll?.(ROOT_SELECTOR).forEach((root) => roots.push(root));

    roots.forEach((root) => filterColorOptions(root));
  }

  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

      const root = target.closest(ROOT_SELECTOR);
      if (!root) return;

      filterColorOptions(root);
    },
    true
  );

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('product-info:loaded', (event) => initialize(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
})();
